import Http from "../../http/client";
import {RequestQueryBuilder} from "@nestjsx/crud-request";

export default async (userId) => {
  const qb = RequestQueryBuilder.create();

  qb.setJoin({field: 'groups'});
  qb.setJoin({field: 'forbidPermissions'});
  qb.setJoin({field: 'extraPermissions'});

  const response = await Http.get('admin/users/'+userId, {
    params: qb.queryObject
  });

  return response.data;
}
